import { DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component, effect } from '@angular/core';
import { DialogBuilderComponent } from 'app/core/dialogBuilder/dialog-builder.component';
import { TableStateService } from '../tableState.service';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoService } from '@ngneat/transloco';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'lib-column-order',
    imports: [CommonModule, DragDropModule, MatIconModule],
    templateUrl: './column-order.component.html',
    styleUrl: './column-order.component.css',
})
export class ColumnOrderComponent extends DialogBuilderComponent<any> {
    _translocoContent: any;

    constructor(
        private stateService: TableStateService,
        private translate: TranslocoService
    ) {
        super();
        this._translocoContent = toSignal(translate.selectTranslation());

        effect(() => {
            const code = this.executeActionSignal();
            if (code === 'submit') {
                this.closeDialog(this.componentModel);
            }
        });
    }

    drop($event: any) {
        moveItemInArray(this.componentModel.columns, $event.previousIndex, $event.currentIndex);
        let state = this.stateService.getState(this.componentModel.tableId);
        if (state) {
            state.displayedColumns = this.componentModel.columns;
        } else {
            state = {
                displayedColumns: this.componentModel.columns,
                formState: null,
                name: this.componentModel.tableId,
            };
        }
        this.stateService.save(state);
    }

    trackByFn(index: number, item: any): any {
        return item.columnName || index;
    }
}
